import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TimelineRow } from './TimelineRow';
import type { TimelineItem } from './types';
import styles from './TreatmentTimeline.module.css';

interface TreatmentTimelineProps {
  items: TimelineItem[];
  strokeColor: string;
  fillColor: string;
  selectedId?: string;
  onItemClick?: (id: string) => void;
}

export const TreatmentTimeline = ({
  items,
  strokeColor,
  fillColor,
  selectedId,
  onItemClick
}: TreatmentTimelineProps) => {
  const { t } = useTranslation();
  const [expandedIds, setExpandedIds] = useState<ReadonlySet<string>>(new Set());

  const toggleExpanded = (id: string) => {
    setExpandedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  return (
    <div className={styles.section}>
      <div className={styles.card}>
        <h3 className={styles.title}>{t('treatment-plan')}</h3>
        <div className={styles.timeline}>
          {items.map((item) => (
            <TimelineRow
              key={item.id}
              item={item}
              isSelected={!!selectedId && item.id === selectedId}
              isExpanded={expandedIds.has(item.id)}
              strokeColor={strokeColor}
              fillColor={fillColor}
              onSelect={onItemClick}
              onToggle={toggleExpanded}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
